module.exports = __webpack_public_path__ + "a245c799e314936c72b08277877bde38.svg";